export default __webpack_public_path__ + "static/media/MellisaLovelace.6c90b96b.png";